module.exports = "/assets/6e9283c570ea04fb000eb362fa12dded.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SV.png
// module id = 2956
// module chunks = 0